import { adminApi } from './clients';

/**
 * Who has access to the staff screens.
 *
 * Only an access manager can reach these; a 403 here means the person is signed in but not one
 * of them, which the screen says rather than showing an empty table.
 */

export const fetchStaffAccess = async () => {
    const { data } = await adminApi.get('/staff-access');
    return data;
};

export const saveStaffAccess = async (person) => {
    const { data } = await adminApi.post('/staff-access', person);
    return data;
};

export const revokeStaffAccess = async (staffMemberId) => {
    const { data } = await adminApi.delete(`/staff-access/${staffMemberId}`);
    return data;
};

/** What the signed-in person may do, according to the server rather than the browser. */
export const fetchAdminSession = async () => {
    const { data } = await adminApi.get('/admin-session');
    return data;
};
